import { CaixaProps } from "../../components/Estrutura/Caixa";

export const salaB: CaixaProps[] = [
  {
    nome: "Sala B",
    descricao: "Bateria - Sala B",
    img: "/assets/Estudio/IMG_4335.jpg",
  },
  {
    nome: "Sala B",
    descricao: "Ar Condicionado - Sala B",
    img: "/assets/Estudio/IMG_4342.jpg",
  },
  {
    nome: "Sala B",
    descricao: "Visão Superior - Sala B",
    img: "/assets/Estudio/IMG_8700.jpg",
  },
  {
    nome: "Sala B",
    descricao: "Visão geral - Sala B",
    img: "/assets/Estudio/IMG_8702.jpg",
  },
  {
    nome: "Sala B",
    descricao: "Visão geral - Sala B",
    img: "/assets/Estudio/IMG_8704.jpg",
  },
  {
    nome: "Sala B",
    descricao: "Visão bateria - Sala B",
    img: "/assets/Estudio/IMG_8706.jpg",
  },
  {
    nome: "Sala B",
    descricao: "Amplificadores de guitarra - Sala B",
    img: "/assets/Estudio/IMG_8708.jpg",
  },
  {
    nome: "Sala B",
    descricao: "Espaço Social 1 - Sala B",
    img: "/assets/Estudio/IMG_8697.jpg",
  },
  {
    nome: "Sala B",
    descricao: "Espaço Social 2 - Sala B",
    img: "/assets/Estudio/IMG_8695.jpg",
  },
];
